import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebook, faXTwitter } from "@fortawesome/free-brands-svg-icons";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";

export default function SocialNav() {
  return (
    <nav className="social-nav" aria-label="MileSoft social links">
      <a
        className="social-nav-link"
        target="_blank"
        rel="noopener noreferrer"
        href="https://fb.me/MileSoft.Africa"
        aria-label="MileSoft on Facebook"
      >
        <FontAwesomeIcon icon={faFacebook} aria-hidden="true" />
      </a>
      <a
        className="social-nav-link"
        target="_blank"
        rel="noopener noreferrer"
        href="https://x.com/MileSoftAfrica"
        aria-label="MileSoft on X"
      >
        <FontAwesomeIcon icon={faXTwitter} aria-hidden="true" />
      </a>
      <a
        className="social-nav-link"
        href="mailto:MileSoft.Africa@gmail.com"
        aria-label="Email MileSoft"
      >
        <FontAwesomeIcon icon={faEnvelope} aria-hidden="true" />
      </a>
    </nav>
  );
}
